import { useState, useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import {
    AccountCircle,
    ListAlt,
    TrackChanges,
    Restaurant,
    Commute,
    Announcement,
} from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../lib/axios';

const BottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = useState(0);
    const [bookings, setBookings] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBookingData = async () => {
            const Mobile = localStorage.getItem("Mobile");
            try {
                const response = await axiosInstance.post('TrnBooking/GetTrnBookingDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: '',
                    Flag:'',
                    MobileNo :Mobile,
                    BookNo:'',
                    PropId:1,
                });
                if (response.data.Status === 0) {
                    setBookings(response.data.Data);
                    //   if (response.data.Data.length > 0) {
                    //     setCurrentBookingIndex(0); 
                    //   }
                } else {
                    setError(response.data.Message);
                }
            } catch (err) {
                setError('Error fetching data');
            } finally {
                setLoading(false);
            }
        };
        fetchBookingData();
    }, []);
    useEffect(() => {
        switch (location.pathname) {
            case '/residentmenu': setValue(0); break;
            case '/res-raise-ticket': setValue(1); break;
            case '/res-ticket-status': setValue(2); break;
            case '/food-service': setValue(3); break;
            case '/transportation': setValue(4); break;
            case '/notice-board':setValue(5); break;
            default: setValue(0);
        }
    }, [location.pathname]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        switch (newValue) {
            case 0: navigate('/residentmenu'); break;
            case 1: navigate('/res-raise-ticket'); break;
            case 2: navigate('/res-ticket-status'); break;
             case 3: 
              navigate('/food-service', {
                state: { bookingsData: bookings }
            });
                break;
            case 4: navigate('/transportation'); break;
            case 5: navigate('/notice-board'); break;
            default: break;
        }
    };

    return (
        <Paper
            elevation={3}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1300,
                display: { xs: 'flex', sm: 'none' }, // Show only on mobile
            }}
        >
            <BottomNavigation value={value} onChange={handleChange} showLabels sx={{ width: '100%' }}>
                <BottomNavigationAction
                    label="Home"
                    icon={<HomeIcon sx={{ fontSize: 20 }} />}
                    sx={{ minWidth: 0, flex: 1 }}
                />
                <BottomNavigationAction
                    label="Ticket"
                    icon={<ListAlt sx={{ fontSize: 20 }} />}
                    sx={{ minWidth: 0, flex: 1 }}
                />
                <BottomNavigationAction
                    label="Track"
                    icon={<TrackChanges sx={{ fontSize: 20 }} />}
                    sx={{ minWidth: 0, flex: 1 }}
                />
                <BottomNavigationAction
                    label="Tiffin"
                    icon={<Restaurant sx={{ fontSize: 20 }} />}
                    sx={{ minWidth: 0, flex: 1 }}
                />
                <BottomNavigationAction
                    label="Transport"
                    icon={<Commute sx={{ fontSize: 20 }} />}
                    sx={{ minWidth: 0, flex: 1 }}
                />
                <BottomNavigationAction
                    label="Notice"
                    icon={<Announcement />}
                    sx={{  minWidth: 0, flex: 1  }}
                />
            </BottomNavigation>
        </Paper>
    );
};

export default BottomNav;
